module.exports = __webpack_public_path__ + "static/media/po-reman-2-4.a89b585b.png";